module.exports = __webpack_public_path__ + "img/four-squares-icon.37899367.svg";